import axiosInstance from '../utils/axiosConfig';

/**
 * Payment terms offered on a CRM partner (debtor / creditor).
 *
 * The options come from the invoicing PaymentTerms catalogue via a
 * CRM-gated endpoint, so this file holds no list of terms. It used to:
 * CRMBankingDetailsTab carried a hardcoded ['Net 30','Net 60','Cash on
 * Delivery'] while the catalogue already had Cash in Advance, Net 7 and
 * Net 45 — and the invoice mappers read the field as a database id, so the
 * display strings that array wrote could never resolve to a due date.
 *
 * Stored form is the term CODE ('NET45'). Display comes from the option's
 * label. Legacy rows may still hold a display string or a numeric id, so
 * every label lookup falls back to showing the raw value rather than an
 * empty tag that reads as "nothing selected".
 */

export const PAYMENT_TERMS_OPTIONS_URL = '/api/crm/payment-terms-options/';

export async function fetchPaymentTermOptions() {
    const response = await axiosInstance.get(PAYMENT_TERMS_OPTIONS_URL);
    return response?.data?.options || [];
}

/** Display label for one stored value; falls back to the value itself. */
export function paymentTermLabel(stored, options = []) {
    if (stored === null || stored === undefined || stored === '') return '';

    const key = String(stored).trim();
    const match = (options || []).find(
        (o) => String(o.value).toLowerCase() === key.toLowerCase()
    );
    if (match) return match.label;

    // Legacy row: a display string, or an id from before codes were stored.
    return key;
}

/**
 * Human-readable summary of a stored selection list.
 * Renders 'Net 30, Net 45' — never the concatenated 'Net 30Net 45' that
 * dropping a raw array into JSX produces.
 */
export function formatPaymentTerms(stored, options = [], emptyValue = '-') {
    const list = Array.isArray(stored) ? stored : stored ? [stored] : [];
    const labels = list
        .map((v) => paymentTermLabel(v, options))
        .filter((label) => label !== '');
    return labels.length ? labels.join(', ') : emptyValue;
}
